import { maybe } from '@passionware/monads';
import { get } from 'lodash';
import { useSelector } from 'react-redux';
import { getExpenseSlotRate } from 'v1/helpers/byModel/ProductionBudgetExpenseHelper.js';
import { RateInterval } from '../../../../../__types__';
import { getProductionResourcing } from '../../../../../store/v1/productions/productions.selectors';
import { ExpenseEntity, ExpenseEntitySpec } from '../types';

export function useExpenseEntity(spec: ExpenseEntitySpec): ExpenseEntity {
  // Fetch data from Redux store
  const productions = useSelector((state: any) => state.productions.data);
  const production = get(productions, [spec.productionId]);

  const slotParents = useSelector(state =>
    // @ts-expect-error -- js ts interoperability
    getProductionResourcing(state, { production_id: spec.productionId })
  ).data;

  const expenseSlot = slotParents.find(x => x.slot.id === spec.slotId)?.slot;

  const expense = (expenseSlot.expenses || []).find(
    expense => !expense.archived && expense.id === spec.expenseId
  );

  if (!production || !expenseSlot) {
    // Return default values if data is not available
    throw new Error('Expense entity not found');
  }

  // Get estimate value from expense slot
  const estimateRate = getExpenseSlotRate(expenseSlot);
  const estimateValue: ExpenseEntity['estimateValue'] = {
    rate: {
      currency: estimateRate.currency || production.budget_currency || 'USD',
      amount: estimateRate.amount ?? 0,
      interval: estimateRate.interval || RateInterval.Daily,
      quantity: estimateRate.quantity ?? 0
    }
  };

  // Get actual value from expense
  const actualValue: ExpenseEntity['actualValue'] = maybe.map(
    expense,
    expense => ({
      rate: {
        currency:
          expense.commit_rate_currency || production.budget_currency || 'USD',
        amount: expense.commit_rate_amount ?? 0,
        interval: expense.commit_rate_interval || RateInterval.Daily,
        quantity: expense.commit_rate_quantity ?? 0
      }
    })
  );

  return {
    estimateValue,
    actualValue,
    currency: production.budget_currency
  };
}
